<template>
    <!-- Vertical Card Layout -->
    <Link v-if="type === 'vertical'" :href="'/artist/' + artist.id"
        class="group block w-full rounded-2xl p-3 text-center transition-colors duration-300 hover:bg-white/[0.05] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent">
        <div class="relative mx-auto aspect-square w-full max-w-[10rem] overflow-hidden rounded-full bg-nomad-800 ring-1 ring-white/10 transition-shadow duration-300 group-hover:shadow-glow">
            <img :src="artist.image" :alt="artist.name" loading="lazy"
                class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </div>
        <h2 class="mt-3 truncate text-[0.9375rem] font-semibold text-white">
            {{ artist.name }}
        </h2>
        <p v-if="artist.songs_count !== undefined" class="mt-0.5 text-xs text-nomad-400">
            {{ artist.songs_count }} {{ artist.songs_count === 1 ? 'song' : 'songs' }}
        </p>
    </Link>

    <!-- Horizontal Card Layout -->
    <Link v-else :href="'/artist/' + artist.id"
        class="group flex w-full items-center gap-4 rounded-2xl p-2 pr-4 transition-colors duration-200 hover:bg-white/[0.05] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent">
        <img :src="artist.image" :alt="artist.name" loading="lazy"
            class="h-14 w-14 shrink-0 rounded-full object-cover ring-1 ring-white/10 sm:h-16 sm:w-16" />
        <div class="min-w-0 flex-1">
            <h2 class="truncate text-[0.9375rem] font-semibold text-white transition-colors group-hover:text-nomad-accent">
                {{ artist.name }}
            </h2>
            <p v-if="artist.songs_count !== undefined" class="mt-0.5 text-sm text-nomad-400">
                {{ artist.songs_count }} {{ artist.songs_count === 1 ? 'song' : 'songs' }}
            </p>
        </div>
        <span class="icon-chevron-right shrink-0 text-nomad-500 opacity-0 transition-all group-hover:translate-x-0.5 group-hover:opacity-100"
            aria-hidden="true"></span>
    </Link>
</template>
<script setup>
defineProps({ artist: Object, type: { type: String, default: "vertical" } });
</script>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
};
</script>
